export default __webpack_public_path__ + "static/media/copy-solid-hover.57bd65b8.svg";